import { extension, PlainExtension } from '@remirror/core';
import { dragHandle, dropIndicator, dropHandler } from './plugins';

export const DragNDropExtension = extension({
  defaultOptions: {
    handlesWidth: 48,
    dropIndicatorWidth: 3,
    dropIndicatorColor: '#BFE5F4',
    dropIndicatorClass: '',
    isDraggableBlock: () => false,
    allowColumnsInsideNode: () => false,
  },
})(
  class DragNDropExtension extends PlainExtension {
    get name() {
      return 'dragndrop';
    }

    createExternalPlugins() {
      return [
        new dragHandle({
          handlesWidth: this.options.handlesWidth,
          isDraggableBlock: this.options.isDraggableBlock,
        }),
        new dropIndicator({
          indicatorWidth: this.options.dropIndicatorWidth,
          indicatorColor: this.options.dropIndicatorColor,
          indicatorClass: this.options.dropIndicatorClass,
          isDraggableBlock: this.options.isDraggableBlock,
        }),
        new dropHandler({
          allowColumnsInsideNode: this.options.allowColumnsInsideNode,
          isDraggableBlock: this.options.isDraggableBlock,
        }),
      ];
    }
  }
);
